var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto w-full pt-16 pb-40",staticStyle:{"max-width":"1134px"}},[_c(_vm.subscriptionComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }